import { ComponentsOverrides, Theme } from '@mui/material';

export const MuiAutocomplete: { styleOverrides: ComponentsOverrides<Theme>['MuiAutocomplete'] } = {
    styleOverrides: {
        hasPopupIcon: {
            paddingRight: 0,
        },
        popupIndicator: {
            color: 'inherit',
        },
        clearIndicator: {
            color: 'inherit',
        },
        option: ({ theme }) => ({
            padding: theme.spacing(1.5, 2),
        }),
        root: {
            // mui-autocomplete adds a form-control with a margin-top
            '& > .MuiFormControl-root': {
                marginTop: 0,
            },

            '& .MuiOutlinedInput-root': {
                padding: 9.5,
            },
        },
    },
};
